const getOptions = (theme: Record<string, any>) => {
    return {
        height: '575',
        colors: [
            theme.palette.primary[50],
            theme.palette.primary[100],
            theme.palette.primary[200],
            theme.palette.primary[500],
            theme.palette.primary[600],
            theme.palette.primary[700],
            theme.palette.primary[300],
            theme.palette.primary[400],
            theme.palette.primary[800],
            theme.palette.primary[900],
        ],
        timeline: {
            colorByRowLabel: true,
        },
        avoidOverlappingGridLines: false,
        hAxis: {
            format: 'MMM dd, HH:mm',
        },
        alternatingRowStyle: false,
    }
}

export default getOptions
